var $1a2c3cc19becb1c5$exports = {};
$1a2c3cc19becb1c5$exports = {
    "backButton": (args)=>`Atgriezties uz ${args.prevMenuButton}`,
    "moreActions": `Citas darb\u{12B}bas`,
    "unavailable": `Nav pieejams, izv\u{113}rsiet, lai skat\u{12B}tu s\u{12B}k\u{101}ku inform\u{101}ciju`
};


export {$1a2c3cc19becb1c5$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
